import { moduleToSortValue } from "helpers/module";
import { formatDay } from "helpers/periods";

const MARKER_GLYPH = { ok: "✓", warn: "!", error: "✕" };

/**
 * How a period joins its neighbours, drawn as bars with a marker on each seam.
 *
 * The slot between two bars is a fixed 44 px whether the gap is one day or six
 * months. Drawing it to scale would make a one-day gap invisible and a long one
 * dominate the row; the real length belongs in the message underneath.
 */
export default function PeriodJoinBars({ module, items }) {
  return (
    <div className={`peb-joinbars peb-mod--${moduleToSortValue(module)}`}>
      <div className="peb-joinbars__row">
        {items.map((item, index) => {
          if (item.type === "slot") {
            return (
              <div
                className={`peb-joinbars__slot ${item.gap ? "" : "peb-joinbars__slot--seamless"}`}
                key={`slot-${index}`}
              >
                <span
                  className={`peb-joinbars__marker peb-joinbars__marker--${item.marker}`}
                  data-glyph={MARKER_GLYPH[item.marker]}
                  role="img"
                  aria-label={item.marker}
                />
              </div>
            );
          }

          return (
            <div
              className={`peb-joinbars__seg ${item.variant === "self" || item.variant === "new" ? "peb-joinbars__seg--self" : ""}`}
              key={`bar-${index}`}
            >
              {item.kind && <span className="peb-joinbars__kind">{item.kind}</span>}
              <div className={`peb-joinbars__bar peb-joinbars__bar--${item.variant} ${item.invalid ? "is-invalid" : ""}`}>
                <span>{item.name}</span>
                <span className="peb-joinbars__bar-range">
                  {formatDay(item.start)} - {formatDay(item.end)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
